import { render } from "./ShowIbayaq.vue?vue&type=template&id=7bf78c76"
import script from "./ShowIbayaq.vue?vue&type=script&lang=js"
export * from "./ShowIbayaq.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__